module.exports = __webpack_public_path__ + "static/img/6_1.2e6bdf5c.png";